import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnlinkedOrderFulfillmentPicturesQueryVariables = Types.Exact<{
  filter: Types.OrderFulfillmentPictureFilter;
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type GetUnlinkedOrderFulfillmentPicturesQuery = { __typename?: 'Query', getUnlinkedOrderFulfillmentPictures: { __typename?: 'GetUnlinkedOrderFulfillmentPicturesResult', total: number, pictures: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url: string, url_full_size: string, order_fulfillment_id?: string | null, created_at: string, created_by_id: string, created_by_name: string, comment?: string | null, taken_at?: string | null, street?: string | null, city?: string | null, country_code?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null }> } };


export const GetUnlinkedOrderFulfillmentPicturesDocument = gql`
    query GetUnlinkedOrderFulfillmentPictures($filter: OrderFulfillmentPictureFilter!, $skip: Int!, $take: Int!) {
  getUnlinkedOrderFulfillmentPictures(filter: $filter, skip: $skip, take: $take) {
    pictures {
      id
      url
      url_full_size
      order_fulfillment_id
      created_at
      created_by_id
      created_by_name
      comment
      taken_at
      street
      city
      country_code
      postal_code
      latitude
      longitude
    }
    total
  }
}
    `;

/**
 * __useGetUnlinkedOrderFulfillmentPicturesQuery__
 *
 * To run a query within a React component, call `useGetUnlinkedOrderFulfillmentPicturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnlinkedOrderFulfillmentPicturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnlinkedOrderFulfillmentPicturesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetUnlinkedOrderFulfillmentPicturesQuery(baseOptions: Apollo.QueryHookOptions<GetUnlinkedOrderFulfillmentPicturesQuery, GetUnlinkedOrderFulfillmentPicturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnlinkedOrderFulfillmentPicturesQuery, GetUnlinkedOrderFulfillmentPicturesQueryVariables>(GetUnlinkedOrderFulfillmentPicturesDocument, options);
      }
export function useGetUnlinkedOrderFulfillmentPicturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnlinkedOrderFulfillmentPicturesQuery, GetUnlinkedOrderFulfillmentPicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnlinkedOrderFulfillmentPicturesQuery, GetUnlinkedOrderFulfillmentPicturesQueryVariables>(GetUnlinkedOrderFulfillmentPicturesDocument, options);
        }
export type GetUnlinkedOrderFulfillmentPicturesQueryHookResult = ReturnType<typeof useGetUnlinkedOrderFulfillmentPicturesQuery>;
export type GetUnlinkedOrderFulfillmentPicturesLazyQueryHookResult = ReturnType<typeof useGetUnlinkedOrderFulfillmentPicturesLazyQuery>;
export type GetUnlinkedOrderFulfillmentPicturesQueryResult = Apollo.QueryResult<GetUnlinkedOrderFulfillmentPicturesQuery, GetUnlinkedOrderFulfillmentPicturesQueryVariables>;